export default "__VITE_PUBLIC_ASSET__e7e3a84b__"